<template>
  <div class="conference">
    <div class="conference-banner">
      <img alt="banner" :src="pageConfig.cover" v-if="pageConfig.cover" />
    </div>
    <!-- <div class="conference-phone">
      <span>支持电话：400-676-6605 | 传承、奉献、发展、共赢</span>
    </div> -->
    <div class="conference-conferenceImg" v-if="pageConfig.meetingSpiritPicUrl">
      <img alt="会议精神图" width="100%" height="100%" :src="pageConfig.meetingSpiritPicUrl" />
    </div>
    <div class="conference-time" v-if="pageConfig.showOpenTimeType == 1">
      <div class="time-desc">
        <p>
          距离<span>{{ pageConfig.openTime }}</span>大会开幕还有
        </p>
        <div>
          <ydk-count-down :time="time"></ydk-count-down>
        </div>
      </div>
    </div>
    <div class="conference-content">
      <conf-menu :menuData="pageConfig.pageList" :liveJumpUrl="pageConfig.liveJumpUrl"
        :signStatus="pageConfig.signStatus" :signflag="pageConfig.signflag" />
    </div>
    <div class="conference-footer">
      <img alt="banner" :src="pageConfig.footPicUrl" v-if="pageConfig.footPicUrl" />
    </div>
    <van-dialog v-model="show" title="温馨提示" confirm="show=false" show-confirm-button>
      <div style="padding: 15px;">
        <p style="font-weight: 800;">尊敬的参会代表：</p>
        <p style="color: rgb(100, 101, 102); font-size: 14px; line-height: 17px; margin-top: 10px; text-indent: 28px;">
          {{ pageConfig.tips }}
        </p>
      </div>
    </van-dialog>
    <div v-if="showSupport === 2" style="text-align:center;padding-bottom: 20px;color: #999999;padding-top: 20px;">
      药大咖医桥云
      提供技术支持</div>
  </div>


</template>
<script>
import { queryConferenceConfig } from "@/config/conference";
import { getEnv, getSystem } from "@/config/utils";
import share from "@/mixins/share";

import ConfMenu from "./components/ConfMenu";
export default {
  name: "Conference",
  mixins: [share],
  components: { ConfMenu },
  data: function () {
    return {
      show: false,
      pageConfig: {
        meetingSpiritPicUrl: "", //会议精神图
        cover: "", //封面
        tipsStatus: 1, //首页提示语   1不显示 2显示
        titleColourCode: "", //头部颜色
        liveJumpUrl: "",
        openTime: "", //会议开始时间
        share: "", //分享
        sharedesc: "", //分享
        pageList: [],
        footPicUrl: "", //底部图
        tips: " ", //首页提示语
        shareimg: "", //分享\
        showOpenTimeType: 0
      },
      time: 0,
      showSupport: 2,
    };
  },
  mounted: function () {
    this.init();
  },
  methods: {
    init() {
      queryConferenceConfig(this.$route.query.code).then(result => {
        console.info(result);
        const { success, data } = result;
        if (success === "ok") {
          if (getEnv() !== "h5") {
            let shars = {};
            shars.shareId = this.$route.query.shareId || "0";
            shars.bizId = this.$route.query.bizId || data.id;
            const { cover, sharedesc, share, id } = data;
            const shareimg = data.shareimg || cover;
            const bizType = "5";
            const url =
              window.location.href.split("?")[0] +
              "?code=" +
              this.$route.query.code;
            this.share(bizType, url, shars, shareimg, sharedesc, share, id);
          }
          document.title = data.projectTitle;
          this.pageConfig = data;
          if (data.showSupport) {
            this.showSupport = data.showSupport;
          }

          console.info(data.openTime);
          const openTime =
            getSystem() === "Ios"
              ? data.openTime.replace(/-/gi, "/")
              : data.openTime;
          console.info(openTime);
          const time = Math.floor(
            new Date(openTime).getTime() - new Date().getTime()
          );

          this.time = time > 0 ? time : 0;
          this.pageConfig.openTime = data.openTime.substr(5, 11);
          if (data.tipsStatus == 2) {
            const token = JSON.parse(localStorage.getItem("TOKEN"));
            const sessToken = sessionStorage.getItem("token");
            if (!sessToken || token.data != sessToken) {
              this.show = true;
            }
            sessionStorage.setItem("token", token.data);
          }
        }
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.conference {
  max-width: 414px;
  min-height: 100vh;
  background: #fff;
  margin: 0 auto;
}

.conference-banner {
  width: 100%;
  max-width: 414px;
}

.conference-banner img {
  width: 100%;
  height: 100%;
  min-height: 180px;
}

.conference-phone {
  background: #fff;
  text-align: center;
  height: 40px;
  font-size: 13px;
  font-weight: 400;
  line-height: 40px;
  color: #5095ef;
  padding: 0 15px;
  margin-bottom: 5px;
}

.conference-time {
  height: 130px;
  background: #fff;
  display: flex;
  justify-content: center;
  flex-direction: column;
  border-top: 5px solid #ededed;
}

.conference-time p {
  padding: 0;
}

.time-desc {
  font-size: 14px;
  color: #999;
  text-align: center;
}

.time-desc p {
  margin-bottom: 15px;
}

.time-desc span {
  color: #3584eb;
}

.conference-content {
  background: #ededed;
  padding: 10px 10px 10px;
}

.conference-footer {
  width: 100%;
}

.conference-footer img {
  width: 100%;
  height: 100%;
}
</style>
